// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dHctcHktNQ {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
}

.dHctYm9yZGVyLXB1cnBsZS0yMDAvMzA {
    border-color: rgba(210, 198, 250, .3);
}

.dHctYm9yZGVyLWI {
    border-bottom-width: 1px;
}

.dHctbWF4LXctc2NyZWVuLXhs {
    max-width: 1280px;
}

.dHctbXgtYXV0bw {
    margin-left: auto;
    margin-right: auto;
}

.dHctcmVsYXRpdmU {
    position: relative;
}

.dHctanVzdGlmeS1iZXR3ZWVu {
    justify-content: space-between;
}

.dHctaXRlbXMtY2VudGVy {
    align-items: center;
}

.dHctZmxleA {
    display: flex;
}

.dHctbWwtOA {
    margin-left: 2rem;
}

menu, ol, ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.dHctZmxleC1zaHJpbms {
    flex-shrink: 1;
}

.dHctbWF4LXcteHM {
    max-width: 20rem;
}

/* New styles added incrementally */
.dHctYmcteWVsbG93LTQwMA {
    --tw-bg-opacity: 1;
    background-color: rgb(251 222 155 / var(--tw-bg-opacity));
}

.dHctcm91bmRlZC0yeGw {
    border-radius: 1rem;
}

.dHctanVzdGlmeS1jZW50ZXI {
    justify-content: center;
}

.dHctdy0xMQ {
    width: 2.75rem;
}

.dHctaC0xMQ {
    height: 2.75rem;
}
.dHctZmxleC0x {
    flex: 1 1;
}

.dHctbXQtMA {
    margin-top: 0;
}

.dHctbWwtMw {
    margin-left: .75rem;
}
.dHctZmxleC1zaHJpbmstMA {
    flex-shrink: 0;
}

.dHctZmxleA {
    display: flex;
}
.dHctYmctcm9zZS0yMDA {
    --tw-bg-opacity: 1;
    background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}

.dHctcm91bmRlZC0yeGw {
    border-radius: 1rem;
}

.dHctanVzdGlmeS1jZW50ZXI {
    justify-content: center;
}

.dHctaXRlbXMtY2VudGVy {
    align-items: center;
}

.dHctdy0xMQ {
    width: 2.75rem;
}

.dHctaC0xMQ {
    height: 2.75rem;
}

.dHctZmxleA {
    display: flex;
}
.dHctZmxleC1ncm93LTA {
    flex-grow: 0;
}

.dHctZmxleC1zaHJpbmstMA {
    flex-shrink: 0;
}

.dHctdy02MA {
    width: 15rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,SAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".dHctcHktNQ {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n}\n\n.dHctYm9yZGVyLXB1cnBsZS0yMDAvMzA {\n    border-color: rgba(210, 198, 250, .3);\n}\n\n.dHctYm9yZGVyLWI {\n    border-bottom-width: 1px;\n}\n\n.dHctbWF4LXctc2NyZWVuLXhs {\n    max-width: 1280px;\n}\n\n.dHctbXgtYXV0bw {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.dHctcmVsYXRpdmU {\n    position: relative;\n}\n\n.dHctanVzdGlmeS1iZXR3ZWVu {\n    justify-content: space-between;\n}\n\n.dHctaXRlbXMtY2VudGVy {\n    align-items: center;\n}\n\n.dHctZmxleA {\n    display: flex;\n}\n\n.dHctbWwtOA {\n    margin-left: 2rem;\n}\n\nmenu, ol, ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.dHctZmxleC1zaHJpbms {\n    flex-shrink: 1;\n}\n\n.dHctbWF4LXcteHM {\n    max-width: 20rem;\n}\n\n/* New styles added incrementally */\n.dHctYmcteWVsbG93LTQwMA {\n    --tw-bg-opacity: 1;\n    background-color: rgb(251 222 155 / var(--tw-bg-opacity));\n}\n\n.dHctcm91bmRlZC0yeGw {\n    border-radius: 1rem;\n}\n\n.dHctanVzdGlmeS1jZW50ZXI {\n    justify-content: center;\n}\n\n.dHctdy0xMQ {\n    width: 2.75rem;\n}\n\n.dHctaC0xMQ {\n    height: 2.75rem;\n}\n.dHctZmxleC0x {\n    flex: 1 1 0%;\n}\n\n.dHctbXQtMA {\n    margin-top: 0;\n}\n\n.dHctbWwtMw {\n    margin-left: .75rem;\n}\n.dHctZmxleC1zaHJpbmstMA {\n    flex-shrink: 0;\n}\n\n.dHctZmxleA {\n    display: flex;\n}\n.dHctYmctcm9zZS0yMDA {\n    --tw-bg-opacity: 1;\n    background-color: rgb(254 205 211 / var(--tw-bg-opacity));\n}\n\n.dHctcm91bmRlZC0yeGw {\n    border-radius: 1rem;\n}\n\n.dHctanVzdGlmeS1jZW50ZXI {\n    justify-content: center;\n}\n\n.dHctaXRlbXMtY2VudGVy {\n    align-items: center;\n}\n\n.dHctdy0xMQ {\n    width: 2.75rem;\n}\n\n.dHctaC0xMQ {\n    height: 2.75rem;\n}\n\n.dHctZmxleA {\n    display: flex;\n}\n.dHctZmxleC1ncm93LTA {\n    flex-grow: 0;\n}\n\n.dHctZmxleC1zaHJpbmstMA {\n    flex-shrink: 0;\n}\n\n.dHctdy02MA {\n    width: 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
